// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_f7-a";
export var fulfillmentFormRail = "_f7-9";
export var headerTitleRow = "_f7-c";
export var orderDetailsWrapper = "_f7-7";
export var orderLinkTrigger = "_f7-2";
export var paymentInformationGrid = "_f7-h";
export var paymentSummaryColumn = "_f7-i";
export var shipmentContainer = "_f7-b";
export var shipmentDetailsMainPane = "_f7-8";
export var shipmentNavigationCard = "_f7-5";
export var shipmentNavigationRail = "_f7-3";
export var shipmentNavigationRailHeader = "_f7-4";
export var shipmentSummaryFact = "_f7-e";
export var shipmentSummaryGrid = "_f7-d";
export var shipmentSummaryMetadataRow = "_f7-f";
export var shipmentSummaryTags = "_f7-g";
export var shipmentWorkspace = "_f7-0";
export var shipmentWorkspaceContent = "_f7-6";
export var shipmentWorkspaceHeader = "_f7-1";